import * as api from '../api'
import { GET_LIVE_DETAILS, GET_MATCH_DETAILS, INCREMENT_LIVE_TIMER, INCREMENT_PERIOD} from '../constants/actionTypes.js'

// Action creator
export const getMatchDetail = (idMatch) => async (dispatch) => {

    try{
        const {data} = await api.getMatchDetail(idMatch)
        dispatch({ type: GET_MATCH_DETAILS, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}